import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import moment from "moment";
import uuid from "uuid";
import { Map, Set } from "immutable";
import styled from "styled-components";

import * as XLSX from "xlsx";

import Select from "react-select";
import { Control } from "../../ui-kit/control";
import { SORT_ORDERS } from "../../../constants/config";
import { SortArrow } from "../../ui-kit/table";
import { getFriendlyRegionsOptions } from "../../rmap/RussiaMap";
import { useStorageListener } from "../../../hooks/useStorage";
import CommonHelper from "../../../services/common-service";
import toast from "react-hot-toast";

function getAllUnisOptions(universities = {}) {
    let allUnis = Object.keys(universities).map(x => universities[x]);
    return allUnis.map(x => {
        return {
            value: x.id,
            label: x?.details?.shortName
        };
    });
}

const ITEMS = [
    {
        name: "Глеб Лебедев",
        invitedFriendsNumber: 5,
        bookingsNumber: 10,
        events: ["Мероприятие 1", "Мероприятие 2", "Мероприятие 3"]
    },
    {
        name: "Александр Петров",
        invitedFriendsNumber: 3,
        bookingsNumber: 2,
        events: ["-"]
    },
    {
        name: "Аркадий Дорофеев",
        invitedFriendsNumber: 10,
        bookingsNumber: 5,
        events: ["Мероприятие 1"]
    }
];

function sortCom(order, onToggle = () => {

}) {
    return (
        <div onClick={() => {
            onToggle();
        }}>
            <SortArrow
                extra={`transform: rotate(180deg); opacity: ${(order == undefined) ? 0.3 : (order == -1 ? 0.3 : 1)};`}
            />
            <SortArrow
                extra={`opacity: ${(order == undefined) ? 0.3 : (order == 1 ? 0.3 : 1)};`}
            />
        </div>
    );
    // return (
    //     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
    //          className="w-6 h-6">
    //         <path strokeLinecap="round" strokeLinejoin="round"
    //               d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5" />
    //     </svg>
    // );

}

export default function AmbStatsTool(props) {
    const {
        from = +moment().add(-1, "months"),
        to = +moment().add(-1, "days"),
        items = ITEMS,
        id
    } = props;

    const [ranges, setRanges] = useState({ from: +props.from, to: +props.to });

    const universities = useStorageListener(`universities`, {});
    // const regionsOptions = getFriendlyRegionsOptions();
    let unisOptions = getAllUnisOptions(universities);

    const [sortBy, setSortBy] = useState(undefined);

    console.log("TOOL: ITEMS = ", items);
    let usedRegions = items.map(x => x.ambassadorRegion).filter(x => x != undefined).reduce((st, x) => st.add(x), Set()).toArray().sort();
    let usedCities = items.map(x => x.city).filter(x => x != undefined).reduce((st, x) => st.add(x), Set()).toArray().sort();
    let usedUnisIds = items.map(x => x.ambassadorUniversityId).filter(x => x != undefined).reduce((st, x) => st.add(x), Set()).toArray().sort();
    unisOptions = unisOptions.filter(x => (usedUnisIds.indexOf(x.value) > -1));

    const regionsOptions = usedRegions.map(x => ({ label: x, value: x }));
    const citiesOptions = usedCities.map(x => ({ label: x, value: x }));

    const [selectedUniId, setSelectedUniId] = useState(undefined);
    const [selectedRegion, setSelectedRegion] = useState(undefined);
    const [selectedCity, setSelectedCity] = useState(undefined);

    let filteredItems = items;
    if (selectedUniId != undefined) {
        filteredItems = filteredItems.filter(x => x.ambassadorUniversityId == selectedUniId);
    }
    if (selectedRegion != undefined) {
        filteredItems = filteredItems.filter(x => x.ambassadorRegion == selectedRegion);
    }
    if (selectedCity != undefined) {
        filteredItems = filteredItems.filter(x => x.city == selectedCity);
    }
    if (sortBy != undefined) {
        filteredItems = filteredItems.sort((a, b) => {
            let { name, order } = sortBy;
            let aVal = a[name];
            let bVal = b[name];
            if (name == "invitedFriendsNumber" || name == "bookingsNumber") {
                aVal = +aVal;
                bVal = +bVal;
            }
            if (aVal == bVal) {
                return 0;
            }
            if (aVal > bVal) {
                return order;
            }
            return -order;
        });
    }

    console.log("render: ranges = ", ranges);

    return (
        <Wrapper>
            <table className="min-w-full leading-normal">
                <thead>
                <tr>
                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Амбассадор
                    </th>

                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        <div className={"flex flex-row items-center"}>
                            Приглашенные друзья
                            <span className={"ml-2"}>
                                {sortCom(sortBy?.name == "invitedFriendsNumber" ? sortBy?.order : undefined, () => {
                                    let order = 1;
                                    if (sortBy == undefined) {
                                        setSortBy({
                                            name: "invitedFriendsNumber",
                                            order: order
                                        });
                                    } else {
                                        if (sortBy.name == "invitedFriendsNumber") {
                                            order = (+sortBy.order) * -1;
                                            setSortBy({
                                                name: "invitedFriendsNumber",
                                                order: order
                                            });
                                        } else {
                                            setSortBy({
                                                name: "invitedFriendsNumber",
                                                order: order
                                            });
                                        }
                                    }
                                })}
                            </span>
                        </div>
                    </th>
                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        <div className={"flex flex-row items-center"}>
                            Количество исполненных бронирований
                            <span className={"ml-2"}>
                                {sortCom(sortBy?.name == "bookingsNumber" ? sortBy?.order : undefined, () => {
                                    let order = 1;
                                    if (sortBy == undefined) {
                                        setSortBy({
                                            name: "bookingsNumber",
                                            order: order
                                        });
                                    } else {
                                        if (sortBy.name == "bookingsNumber") {
                                            order = (+sortBy.order) * -1;
                                            setSortBy({
                                                name: "bookingsNumber",
                                                order: order
                                            });
                                        } else {
                                            setSortBy({
                                                name: "bookingsNumber",
                                                order: order
                                            });
                                        }
                                    }
                                })}
                            </span>
                        </div>
                    </th>
                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        <div className={"flex flex-row items-center"}>
                            Мероприятия
                            {/*<span className={"ml-2"}>*/}
                            {/*    {sortCom()}*/}
                            {/*</span>*/}
                        </div>

                    </th>
                </tr>
                </thead>
                <tbody>
                {filteredItems.map((x, i) => {
                    return (
                        <tr key={i}>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                                <p className="text-gray-900 whitespace-no-wrap text-center" onClick={() => {
                                    window.alert(x?.email);
                                }}>
                                    {`${x.name}`}
                                </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                                <p className="text-gray-900 whitespace-no-wrap text-center">
                                    {x.invitedFriendsNumber}
                                </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                                <p className="text-gray-900 whitespace-no-wrap text-center">
                                    {x.bookingsNumber}
                                </p>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <p className="text-gray-900 whitespace-no-wrap">
                                    {x.events.join(", ")}
                                </p>
                            </td>
                        </tr>
                    );
                })}

                </tbody>
            </table>

            <div className={"mt-2"}>

                <div className={"text-gray-400"}>
                    Фильтры
                </div>

                <div>
                    <Control.DateRange name="dateRange"
                                       label={""} placeholder={""}
                                       value={ranges}
                                       onChange={x => {
                                           if (`${ranges?.from}` != `${x?.target?.value?.from}` || `${ranges?.to}` != `${x?.target?.value?.to}`) {
                                               console.log(`FROM1: ${ranges?.from}`);
                                               console.log(`FROM2: ${x?.target?.value?.from}`);
                                               console.log(`TO1: ${ranges?.to}`);
                                               console.log(`TO2: ${x?.target?.to}`);
                                               console.log("ranger: x = ", x);
                                               setRanges(x.target.value);
                                           }

                                       }}
                    />
                </div>

                <div className={"flex flex-row justify-evenly"}>
                    <div className={"mt-2 flex-1 pr-10"}>
                        <Select placeholder={"Город"}
                                options={citiesOptions}
                                isClearable={true}
                                onChange={x => {
                                    setSelectedCity(x?.value);
                                }}
                        />
                    </div>
                    <div className={"mt-2 flex-1 px-10"}>
                        <Select placeholder={"Регион"}
                                options={regionsOptions}
                                isClearable={true}
                                onChange={x => {
                                    setSelectedRegion(x?.value);
                                }}
                        />
                    </div>
                    <div className={"mt-2 flex-1 pl-10"}>
                        <Select placeholder={"Вуз"}
                                options={unisOptions}
                                isClearable={true}
                                onChange={x => {
                                    setSelectedUniId(x?.value);
                                }}
                        />
                    </div>
                </div>

                <div className={"mt-2 text-center"}>
                    <button className={"bg-green-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"}
                            onClick={() => {
                                // let s = `Амбассадор;Приглашенные друзья;Количество исполненных бронирований;Мероприятия\n`;
                                // filteredItems.forEach(x => {
                                //     s += `${x.name};${x.invitedFriendsNumber};${x.bookingsNumber};${x.events.join(", ")}\n`;
                                // });
                                // CommonHelper.downloadFile(`статистика.csv`, s);
                                // toast.success("Файл сформирован");
                                //
                                const wb = XLSX.utils.book_new();
                                const ws = XLSX.utils.aoa_to_sheet([]);

                                // Adding data to the worksheet
                                XLSX.utils.sheet_add_aoa(ws, [["Амбассадор", "Приглашенные друзья", "Количество исполненных бронирований", "Мероприятия"]]);

                                filteredItems.forEach(item => {
                                    XLSX.utils.sheet_add_aoa(ws, [[item.name, item.invitedFriendsNumber, item.bookingsNumber, item.events.join(", ")]], { origin: -1 });
                                });

                                // Adding the worksheet to the workbook
                                XLSX.utils.book_append_sheet(wb, ws, "Report");

                                // Generate a CSV file and trigger download
                                XLSX.writeFile(wb, "статистика.xlsx");

                                toast.success("Файл сформирован");

                            }}
                    >
                        Сформировать отчет
                    </button>
                </div>
            </div>

        </Wrapper>
    );
}

const Wrapper = styled.div`
  padding-bottom: 10px;
`;